// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button .related-button-sample[data-v-2b56f0ec],.button .related-button-read[data-v-2b56f0ec],.button .related-button-detail[data-v-2b56f0ec]{color:#fff}.dark-mode .related-button-sample[data-v-2b56f0ec],.dark-mode .related-button-read[data-v-2b56f0ec],.dark-mode .related-button-detail[data-v-2b56f0ec]{color:#e0e0e0}\n", ""]);
// Exports
module.exports = exports;
